import React from 'react'
import { Skeleton, Button, Collapse, Form, Input, message, Row, Col, Tag } from 'antd'
import { ShelterKioskReasonContextData } from '../../../../context/ShelterKioskReasonContext'
import { FormComponent } from '../../../BaseComponent'
import { ShelterKioskReasonSmartResponseRequest } from '../../../../services/api/interfaces/ApiRequest'
import { IResponseTemplate } from '../../../../interfaces/IResponseTemplate'
import { MagicLinkProvider, MagicLinkConsumer } from '../../../../context/MagicLinkContext'
import MagicLink from './Helpers/MagicLink'

type ReasonSmartResponseProps = {
  branchUuid: string,
  reasonUuid: string,

  context: ShelterKioskReasonContextData
}

export default class ReasonSmartResponse extends FormComponent<ReasonSmartResponseProps> {

  state = {
    loaded: false,
    showMagicLink: false
  }

  private textAreaRef: any = null

  async componentDidMount() {
    const { branchUuid, reasonUuid, context } = this.props

    await context.requestShelterKioskReasonSmartResponseGet({
      organization_branch_uuid: branchUuid,
      organization_kiosk_reason_uuid: reasonUuid
    })

    this.setState({
      loaded: true
    })
  }

  private extractSR = (smartResponse: IResponseTemplate | null) => {
    if (!smartResponse?.json) {
      return {
        models: [],
        values: null
      }
    }

    return {
      models: Object.keys(smartResponse.json.model || {}).map(k => {
        return {
          key: k,
          value: smartResponse.json.model[k]
        }
      }),
      values: smartResponse.json.values
    }
  }

  private handleInsertToken = (token: string) => {
    if (this.textAreaRef?.resizableTextArea?.textArea) {
      const textArea = this.textAreaRef?.resizableTextArea?.textArea
      let message = this.formRef.getFieldValue('message')

      const insert = `{{${token}}}`

      if (textArea.selectionStart === 0) {
        message += insert
      } else {
        message = message.substring(0, textArea.selectionStart) + insert + message.substring(textArea.selectionEnd, message.length)
      }

      this.formRef.setFieldsValue({
        message
      })
    }
  }

  private toggleShowMagicLink = (value?: boolean) => {
    this.setState((state: any) => ({
      ...state,
      showMagicLink: value === undefined ? !state.showMagicLink : value
    }))
  }

  private handleSave = async (values: any) => {
    const { branchUuid, reasonUuid, context } = this.props
    
    try {
      const payload: ShelterKioskReasonSmartResponseRequest = {
        organization_branch_uuid: branchUuid,
        organization_kiosk_reason_uuid: reasonUuid,
        message: values.message
      }

      await context.requestShelterKioskReasonSmartResponseSave(payload)
      message.success('Reason smart response saved successfully!')
    } catch (err) {
      message.error(`Could not save reason smart response. ${err}`)
    }
  }

  render() {
    const { context } = this.props
    const { loaded, showMagicLink } = this.state
    
    if (!loaded) {
      return <Skeleton />
    }

    const smartResponse = this.extractSR(context.smartResponse)

    const values = {
      message: smartResponse.values?.sms_text
    }

    return (
      <Collapse>
        <Collapse.Panel key="options" header="Kiosk Reason SMS Smart Response">
          <Form
            name="shelter_kiosk_reason"
            initialValues={values}
            ref={(refs) => this.formRef = refs}
            onFinish={this.handleSave}
          >
            <Row style={{marginBottom: 10}}>
              <Col style={{marginRight: 10}}>Variables: </Col>

              {
                smartResponse.models.map(v => (
                  <Col key={`token-${v.key}`}>
                    <Tag
                      color="cyan"
                      style={{cursor: 'pointer'}}
                      onClick={() => this.handleInsertToken(v.key)}
                    >
                      {v.value}
                    </Tag>
                  </Col>
                ))
              }
            </Row>

            <Row style={{marginBottom: 10}}>
              <Col style={{marginRight: 10}}>Helpers: </Col>

              <Col>
                <Tag
                  color="geekblue"
                  style={{cursor: 'pointer'}}
                  onClick={() => this.toggleShowMagicLink(true)}
                >
                  Add link
                </Tag>
              </Col>
            </Row>

            <Form.Item
              label="Notification message"
              name="message"
              rules={[
                {
                  required: true,
                  message: 'Message is required'
                }
              ]}
            >
              <Input.TextArea
                ref={(refs) => this.textAreaRef = refs}
                maxLength={140}
                showCount
              />
            </Form.Item>

            <Form.Item style={{ marginTop: 32 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={context.fetching || false}
                ref={(refs) => this.actionRefs.save = refs}
                block
              >
                Save
              </Button>
            </Form.Item>
          </Form>

          <MagicLinkProvider>
            <MagicLinkConsumer>
              {(context) => (
                <MagicLink 
                  visible={showMagicLink}
                  context={context}
                  onClose={() => this.toggleShowMagicLink(false)}
                />
              )}
            </MagicLinkConsumer>
          </MagicLinkProvider>
        </Collapse.Panel>
      </Collapse>
    )
  }
}